import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavigateRoutes, QK_CONSTATANT, RequestType, StorageConstants, TECH_CONSTATANT } from 'common/constants/app.constant';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { StorageService } from 'common/services/core_services/storage.service';
import { SystemService } from 'common/services/core_services/system.service';

@Injectable({
    providedIn: 'root',
})
export class PostloginGuard implements CanActivate {
    constructor(private systemService: SystemService, private storageService: StorageService) {


    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        let userData = JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile));
        const userType = JSON.parse(this.systemService.getLocalStorage(StorageConstants.loginUserType));
        const isEmployeeLogin = JSON.parse(this.systemService.getLocalStorage(StorageConstants.isEmployeeLogin));
        if (this.systemService.isPriLoginTransaction || userType === 0 || userType === 7) {
            return true;
        }



        if (userData) {
            let isLoggedIn = userData;
            //Condition for Non IFA user
            if (userData.type === 'NON_IFA_USER' && ([NavigateRoutes.distributordashboard, NavigateRoutes.brokeragereportpayout, NavigateRoutes.investor, NavigateRoutes.oppotunity, NavigateRoutes.statement, NavigateRoutes.wishes, NavigateRoutes.accoutStatments, NavigateRoutes.capitalGainStatements, NavigateRoutes.transactionHistory].includes(state.url) || state.url.includes('opportunity'))) {
                const routeMsg = new RouteMessage();
                routeMsg.type = RequestType.BLANK;
                this.systemService.routeByUrl(NavigateRoutes.initiateTransaction, routeMsg);
                return false;
            }
            if (this.systemService.deviceInfo.platform !== 'web' && !this.systemService.getSesstionStorage(StorageConstants.isLoginSuccessOnMob)) {
                this.storageService.clearStorage();
                const routeMessage = new RouteMessage();
                routeMessage.type = RequestType.BLANK;
                this.systemService.routeByUrl(NavigateRoutes.loginViaOtp, routeMessage);
                return false;
            }

            if (isEmployeeLogin && state.url === NavigateRoutes.distributorprofile) {
                const routeMsg = new RouteMessage();
                routeMsg.type = RequestType.ID;
                this.systemService.routeByUrl(NavigateRoutes.distributordashboard, routeMsg);
                return false;
            }
            if (isLoggedIn && (QK_CONSTATANT.includes(userData.arnNo) || TECH_CONSTATANT.includes(userData.arnNo)) && state.url !== NavigateRoutes.initiateTransaction && state.url !== NavigateRoutes.notifications && state.url !== NavigateRoutes.distributorprofile) {
                const routeMsg = new RouteMessage();
                routeMsg.type = RequestType.BLANK;
                this.systemService.routeByUrl(NavigateRoutes.initiateTransaction, routeMsg);
                return false;
            }
            if (isLoggedIn) {
                return true;
            } else {
                const routeMessage = new RouteMessage();
                routeMessage.type = RequestType.GET;
                this.systemService.routeByUrl(NavigateRoutes.welcome, routeMessage);
            }
        } else {
            const routeMsg = new RouteMessage();
            routeMsg.type = RequestType.BLANK;
            routeMsg.transferData = null;
            this.systemService.routeByUrl(NavigateRoutes.baselogin, routeMsg);
            return false;
        }
    }
}
